import { DataServiceService } from './../../services/data-service.service';
import { Component, OnInit, Input } from '@angular/core';
import { ProductModel } from 'src/app/model/selfcareproducts';
import { CyberPayLogModel, CyberPay, CyberPaySetTransactionRequest } from 'src/app/model/CyberPay';
import { PaymentService } from 'src/app/services/payment.service';
import { Guid } from 'guid-typescript';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from 'src/app/services/common/configuration.service';
import { UserModel } from 'src/app/model/UserModel';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-cartout',
  templateUrl: './cartout.component.html',
  styleUrls: ['./cartout.component.css']
})
export class CartoutComponent implements OnInit {

  ProductPrice: number;
  ProductName:string;
  ProductDesc:string;
  AmountPayable:number;
    aproduct: ProductModel;



  constructor(private data: DataServiceService, private paymentService:PaymentService,
     private config: ConfigurationService,
     private authenticationService:AuthenticationService) { 
   
  
    this.data.currenProduct.subscribe(message => this. aproduct = message);
    this.AmountPayable =this. aproduct.Price;
    this.ProductPrice  = this.aproduct.Price;
    this.ProductDesc =this. aproduct.Caption;
    this.ProductName =this. aproduct.Name;

      
  }
  postproduct(){
   if (!this.aproduct)
   {

   }
   
   let currentUser: UserModel = this.authenticationService.getCurrentUser();
   let fullname = currentUser.FirstName + " " + currentUser.LastName;

   let cyberPay = {} as CyberPay;
   cyberPay. RedirectLink = environment.CyberPayReturnURL
   cyberPay.portalCode =environment.PortalCode;;
   cyberPay.CustomerID =   parseInt( currentUser.i_Customer);
   cyberPay.provider_id = 4;
   cyberPay.CustomerDesc = fullname;
   cyberPay.Email = currentUser.UserName;
   cyberPay.Value = this.aproduct.Price;
   cyberPay.  FullName = fullname;
   cyberPay.Session = "NewSignUp-"+ currentUser.i_Customer + "-" +  Guid.create().toString().toUpperCase().split('-').join('')
   cyberPay. ItemCode =this.aproduct.i_product.toString();
   cyberPay. ItemName = "Prospect";
   cyberPay.PhoneNumber =  "";
   cyberPay.amount = this.aproduct.Price;
   cyberPay.i_product = this.aproduct.i_product;  
   
 
  this.PostCyberpay(cyberPay);


  }

  PostCyberpay(cyberPay: CyberPay)
  {
 
    let cyberPayModel = {} as CyberPay;
    let MerchantRef = Guid.create().toString().toUpperCase().split('-').join('');
    
    
    cyberPay.RedirectLink= environment.CyberPayReturnURL;//this.config.CyberPayReturnURL;
   
    let cyberPayPaymentRequest = {} as CyberPaySetTransactionRequest;
    cyberPayPaymentRequest.Currency = "NGN";
    cyberPayPaymentRequest.CustomerId = cyberPay.CustomerID.toString();
    cyberPayPaymentRequest.Amount =  cyberPay.amount;
     cyberPayPaymentRequest.CustomerEmail = cyberPay.Email;
    cyberPayPaymentRequest.MerchantRef =MerchantRef;
    cyberPayPaymentRequest.CustomerMobile= cyberPay.PhoneNumber;
    cyberPayPaymentRequest.CustomerName=cyberPay.FullName ;
    cyberPayPaymentRequest.Description = cyberPay.ItemName + "-" + cyberPay.i_account;
    cyberPayPaymentRequest.IntegrationKey=environment.IntegrationKey;
     cyberPayPaymentRequest.ReturnUrl = environment.CyberPayReturnURL;
     cyberPayPaymentRequest.ProductCode = cyberPay.i_product.toString();
     cyberPayPaymentRequest.WebhookUrl = environment.webhookUrl;
     
     
     
    
   let serialisedPayload :string = JSON.stringify(cyberPayPaymentRequest).toString();


     
    this.paymentService.cyberPaySetTransaction(cyberPayPaymentRequest).subscribe(    
      res => {    
        
        if(res.succeeded== true)    
        {       
          


          let date: Date = new Date();
       
            

            var robj = res.data;
            var redirectUr = robj.redirectUrl;
            var transactionReference =robj. transactionReference;
            //var TheObj = robj.data;
            //var redirectUr = TheObj.redirectUrl;
            
  
          
            window.location.href = redirectUr;


   // Log Cyberpay Request

  
   let cyberPayLogModel = {} as CyberPayLogModel;

   cyberPayLogModel.CustomerDesc = cyberPay.CustomerDesc;
   cyberPayLogModel.CustomerID = cyberPay.CustomerID;
   cyberPayLogModel.DateCreated= date.toDateString();
   cyberPayLogModel.Email=cyberPay.Email;
   cyberPayLogModel.FullName = cyberPay.FullName;
   cyberPayLogModel.IsSuccessful = false;
   cyberPayLogModel.ItemCode = cyberPay.ItemCode;
   cyberPayLogModel.ItemName = cyberPay.ItemName;
   cyberPayLogModel.OperatorID = cyberPay.OperatorID;
   cyberPayLogModel.PhoneNumber = cyberPay.PhoneNumber;
   cyberPayLogModel.PortalCode = cyberPay.portalCode;
   cyberPayLogModel.RedirectLink=cyberPay.RedirectLink;
   cyberPayLogModel.Request_Payload=serialisedPayload;
   cyberPayLogModel.Session=cyberPay.Session;
   cyberPayLogModel.Transaction_status="PENDING";;
   cyberPayLogModel.Value =cyberPay.amount;
   cyberPayLogModel.amount = cyberPay.amount;
   cyberPayLogModel.i_account=cyberPay.i_account;
   cyberPayLogModel.i_customer=cyberPay.i_customer;
   cyberPayLogModel.i_product = cyberPay.i_product;
   cyberPayLogModel.TransRef = transactionReference;
 

   
  
 
   this.paymentService.LteHttpLogCyberPayRequest(cyberPayLogModel).subscribe(res=>{
    console.log(res);
  });


   

       

         // window.location.href = data.data.redirectUrl;


     
          
        

         // this.router.navigate(['/dashboard']);    
         
        }    
        else{   
       
          //this._notificationservice.error("Error logging in"); 
          
              
       //   this.errorMessage = data.Message;    
         // this.alertService.error(this.errorMessage);
        }    
      },     
      error => {    
         
       // this.loading = false;  
      //  this._notificationservice.error("Error logging in"); 

       
      }); 


  }







  ngOnInit() {
  }

}
